import {v4 as uuid } from 'uuid';
import isEmpty from 'lodash/isEmpty';
/* 
 * initialize fields on every widget launch
 * @autifill subscriber fields on launch
 */

function initFieldValues () {
    const env = this.env;
    const appStore = env.appStore;
    const schedulesStore = env.schedulesStore;
    const location = appStore.location;
    const statesStore = this;
    this.subscribersFields = initSubscribersFields({
        statesStore,
        appStore,
        schedulesStore,
        location,
        widget: appStore.widget,
    });

    this.customValues = initCustomValues({
        statesStore,
        appStore,
        schedulesStore,
        location,
        widget: appStore.widget,
    });

    this.optinValues = initOptinValues({
        statesStore,
        appStore,
        schedulesStore,
        location,
        widget: appStore.widget,
        optins: appStore.optins,
    });

    this.cursorPositions = initCursorPositions({
        statesStore,
    });
    this.cursorTarget  = {};

    this.captureFields();
    this.observed.subscribersFields = uuid();
    this.observed.customValues = uuid();
    this.observed.optinValues = uuid();
    this.observed.cursorPositions = uuid();
}

function initCursorPositions (p) {
    const cursorPositions = {};
    cursorPositions.email = { start: 0, end: 0 };
    return cursorPositions;
} 

function initSubscribersFields (p) {
    const {
        statesStore,
        widget,
        appStore,
    } = p;
    // console.log('initSubscribersFields(): Widget: ', widget );
    
    if (isEmpty(statesStore.autofillFields)) {
        statesStore.autofillFields = {};
    }

    const fieldValues = {
        dob: '',
        age_group: '',
        first_name: '',
        last_name: '',
    };

    for (let key in widget.registration_fields) {
        const item = widget.registration_fields[key];
        if (key !== 'dob' && key !== 'dateOfBirth' && key !== 'name') {
            fieldValues[key] = '';
        }
         // registered requried fields
         registerRequiredField({
            item,
            statesStore,
            key,
         });

         if (!isEmpty(statesStore.paramFieldValues) && !isEmpty(statesStore.paramFieldValues[key])) {
                const value = statesStore.paramFieldValues[key];
                if (key === 'mobile') {
                    fieldValues.phoneNumber = value;
                    statesStore.autofillFields.mobile = true;
                }
            fieldValues[key] = value;
            statesStore.autofillFields[key] = true;
         }
    }

    let selectedCalendar = 'ics_other';
    if (statesStore.selectedCalendar) {
        selectedCalendar = statesStore.selectedCalendar;
    }

    if (selectedCalendar === 'apple' || selectedCalendar === 'ics_other') {
        if (statesStore.paramFieldValues.email) {
            fieldValues.email = statesStore.paramFieldValues.email;
        }
        statesStore.autofillFields.email = false;
    } else {
        if (appStore.oauthEmail) {
            fieldValues.email = appStore.oauthEmail;
            statesStore.autofillFields.email = true;
        }
    }

    return fieldValues;
}

function registerRequiredField ({ item, statesStore, key,  }) {
    if (item === 1) {

        if (key === 'parentalConsentAge') {
            statesStore.addRequired('parentConsentOn');
            return;
        }
        
        if (key === 'dob') {
            statesStore.addRequired('age_group');
        } else if (key === 'dateOfBirth') {
            statesStore.addRequired('dob');
        } else if (key === 'name') {
            statesStore.addRequired('first_name');
            statesStore.addRequired('last_name');
        } else {
            statesStore.addRequired(key);
        }
    }
}

function initCustomValues (p) {
    const {
        widget,
        statesStore,
    } = p;
    const values = {};
    for (let i = 0; i < widget.custom_fields.length; i++) {
        const item =  widget.custom_fields[i];
        if (item.required && item.visible) {
            statesStore.addRequired(item.name);
        }
    }
    return values;
}

function initOptinValues (p) {
    const {
        statesStore,
        optins,
    } = p;
    const values = {};
    for (let i = 0; i < optins.length; i++) {
        const optin = optins[i];
        if (!optin.optional) {
            statesStore.addRequired(optin.name);
        }
        values[optin.name] = {
            value: optin.isSelected,
            ...optin,
        };
    }
    return values;
}

export default initFieldValues;
